
/**
 * Simple page displayed when user uses incorect URL
 * Might be nice to improve the visuals of this information.
 * @returns {Component} <p>
 */
export function PageNotFound() {
  return <p>Page not found</p>;
}
